export default "__VITE_ASSET__BCFUp7EG__"